/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { ReactNode } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { IconButton, Tooltip } from "@mui/material";
import "../../../../pages/styles.scss";
import { IconEye } from "@tabler/icons-react";

// Declaring props types for CompleStatisticsCard
interface Props {
  color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";
  title: ReactNode;
  count: string | number;
  percentage?: {
    color: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "dark" | "white";
    amount: string | number;
    label: string;
  };
  colorHexa?: string;
  tituloOjo?: string;
  icon: ReactNode;
  onEyeClick?: () => void;
  [key: string]: any;
}

function ComplexStatisticsCard({
  color,
  title,
  count,
  percentage,
  tituloOjo,
  icon,
  colorHexa,
  onEyeClick,
}: Props): JSX.Element {
  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
          sx={{ background: colorHexa }}
          className="efecto-hover-cards"
        >
          {icon}
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography variant="button" fontWeight="light" color="text">
            {title}
          </MDTypography>
          <MDTypography variant="h4">{count}</MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox pb={2} px={2}>
        <MDBox display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography component="p" variant="button" color="text" display="flex">
            <MDTypography
              component="span"
              variant="button"
              fontWeight="bold"
              color={percentage?.color}
            >
              {percentage?.amount}
            </MDTypography>
            &nbsp;{percentage?.label}
          </MDTypography>
          {onEyeClick && (
            <Tooltip title={tituloOjo ?? ""}>
              <IconButton
                size="small"
                onClick={onEyeClick}
                sx={{ color: "text.secondary", p: 0.5 }}
              >
                <IconEye size={24} stroke={2} />
              </IconButton>
            </Tooltip>
          )}
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Declaring defualt props for ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

export default ComplexStatisticsCard;
